import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isShowModal: false,
  type: "",
  title: "",
  payload: null,
  items: [],
  currentIndex: -1,
};

const clampIndex = (index, length) => {
  if (!length) return -1;
  if (index < 0) return 0;
  if (index >= length) return length - 1;
  return index;
};

const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    openPageModal(state, action) {
      const {
        modalType = "",
        title = "",
        data = null,
        items = [],
        currentIndex = 0,
      } = action.payload ?? {};

      const normalizedItems = Array.isArray(items) ? items : [];
      const resolvedIndex = clampIndex(currentIndex, normalizedItems.length);
      const resolvedPayload =
        resolvedIndex > -1 ? normalizedItems[resolvedIndex] : data;

      state.isShowModal = true;
      state.type = modalType;
      state.title = title || resolvedPayload?.title || "";
      state.payload = resolvedPayload;
      state.items = normalizedItems;
      state.currentIndex = resolvedIndex;
    },
    closePageModal(state) {
      Object.assign(state, initialState);
    },
    setPageModalIndex(state, action) {
      if (!state.items.length) return;

      const nextIndex = clampIndex(Number(action.payload), state.items.length);
      state.currentIndex = nextIndex;
      state.payload = state.items[nextIndex];
      state.title = state.items[nextIndex]?.title || state.title;
    },
    showPrevPageModalItem(state) {
      if (!state.items.length) return;

      const nextIndex = clampIndex(state.currentIndex - 1, state.items.length);
      state.currentIndex = nextIndex;
      state.payload = state.items[nextIndex];
      state.title = state.items[nextIndex]?.title || state.title;
    },
    showNextPageModalItem(state) {
      if (!state.items.length) return;

      const nextIndex = clampIndex(state.currentIndex + 1, state.items.length);
      state.currentIndex = nextIndex;
      state.payload = state.items[nextIndex];
      state.title = state.items[nextIndex]?.title || state.title;
    },
    setIsShowModal(state, action) {
      const {
        isShowModal = false,
        type = "",
        title = "",
        data = null,
      } = action.payload ?? {};

      if (!isShowModal) {
        Object.assign(state, initialState);
        return;
      }

      state.isShowModal = true;
      state.type = type;
      state.title = title;
      state.payload = data;
      state.items = [];
      state.currentIndex = -1;
    },
    setIsCloseModal(state) {
      Object.assign(state, initialState);
    },
  },
});

export const {
  openPageModal,
  closePageModal,
  setPageModalIndex,
  showPrevPageModalItem,
  showNextPageModalItem,
  setIsShowModal,
  setIsCloseModal,
} = modalSlice.actions;
export default modalSlice.reducer;
